module.exports = __webpack_public_path__ + "static/images/icon-movie-new3.47aeea5.png";